import { ENRICHMENT_CATEGORY_TYPE_PROFILE } from 'common-data-handling';
import { sortBy } from 'lodash';
import { useMemo } from 'react';
import { useEnrichmentQuestions } from './useEnrichmentQuestions';


export function useProfileEnrichments(eventId, { filter, sortBy: orderBy } = {}) {
    const questions = useEnrichmentQuestions(eventId);
    return useMemo(() => {
        let result = questions.filter(q => q.question.category == ENRICHMENT_CATEGORY_TYPE_PROFILE && q.question.visible_on_profile);

        if (filter) result = result.filter(filter);
        if (orderBy) result = sortBy(result, orderBy);

        return result;
    }, [questions, filter, sortBy]);
}
